/**
 * Debug utility - disabled for production
 */
const DEBUG = false;

export const log = DEBUG ? console.log.bind(console) : () => {};
export const warn = DEBUG ? console.warn.bind(console) : () => {};
export const error = console.error.bind(console); // Always log errors

export default { log, warn, error };
